// extracted by mini-css-extract-plugin
export default {"language":"MenuLanguage_language__3yb3-"};